import { saveRequestCorporateAccountRequest } from "../../../../app/api/requestCorporateAccount";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { isEmpty } from "../../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../../Orchestrator/Types/Index";
import { ISaveRequestCorporateAccountParams } from "../../../../Orchestrator/Types/Interface/ActionParams/RequestCorporate";
import { IRequestCorporateAccountRequest, IRequestCorporateAccountResponse } from "../../../../Orchestrator/Types/Interface/IRequestcorporate";


class SaveRequestCorporateAccount extends BaseAction<string, ISaveRequestCorporateAccountParams> {
    /**
     * @function validateForm only use once action call from test file.
    */
    validateForm = () => {
        let result = {
            isValid: true,
            message: ""
        }
        const { oldDetails } = this.params!
        const fields = ["companyName", "activitySector", "commercialLicense", "cityUAE", "accountAdminFirstName", "accountAdminLastName", "email", "phoneNumber"] as const;
        type FieldKey = typeof fields[number];
        const validationMessage: Record<FieldKey, string> = {
            companyName: "Company Name is required",
            activitySector: "Activity Sector is required",
            commercialLicense: "License Number is required",
            cityUAE: "City is required",
            accountAdminFirstName: "First Name is required",
            accountAdminLastName: "Last Name is required",
            email: "Email is required",
            phoneNumber: "Phone Number is required",
        }
        for (let i = 0; i < fields.length; i++) {
            const key = fields[i];
            if (isEmpty(oldDetails[key])) {
                result = {
                    isValid: false,
                    message: validationMessage[key]
                }
                break;
            } else {
                if (key === "companyName") {
                    const regex = /^[\s\S]{2,100}$/;
                    if (!regex.test(oldDetails[key])) {
                        result = {
                            isValid: false,
                            message: "Company Name must be 2-100 characters, alphabets, numbers, special characters are allowed"
                        }
                        break;
                    }
                }
            }
        }
        return result
    }
    override async run(): Promise<string> {
        let actionResponse = "fail";
        try {
            const { oldDetails, isFrom = "" } = this.params!
            if (oldDetails) {
                let callAPI = true
                const payload: IRequestCorporateAccountRequest = {
                    name: oldDetails.companyName,
                    admin: {
                        firstName: oldDetails.accountAdminFirstName,
                        lastName: oldDetails.accountAdminLastName,
                        email: oldDetails.email,
                        phoneNumber: oldDetails.mobileCode + oldDetails.phoneNumber,
                    },
                    data: {
                        commercialLicenseNumber: oldDetails.commercialLicense,
                        activitySector: oldDetails.activitySector,
                        address: {
                            street: oldDetails.cityUAE,
                            city: oldDetails.cityUAE
                        }
                    }
                }
                if (isFrom === "testFile") {
                    const formValidate = this.validateForm()
                    callAPI = formValidate?.isValid || false
                    if (!callAPI) {
                        actionResponse = formValidate?.message || ""
                    }
                }
                if (callAPI) {
                    const response: IApiResponse<IRequestCorporateAccountResponse> = await saveRequestCorporateAccountRequest(payload);
                    if (response.code === 200 && response.answer) {
                        actionResponse = "success"
                        updateRecoilState("corporateFormSubmittedAtom", true)
                    } else {
                        actionResponse = "Something went wrong"
                    }
                }
            }

        } catch (error: any) {
            actionResponse = error?.message || ""
            console.error("Error fetching Cities :", error);
        }
        finally {
            return actionResponse
        }
    }
}

export const saveRequestCorporateAccount = new SaveRequestCorporateAccount()


